import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { useEffect, useRef, useState } from 'react';

export const VirtualizedListCheckbox = ({
  data,
  itemHeight = 40,
  containerHeight = 300,
  form,
  fromV2 = false,
}) => {
  const containerRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const visibleItems = useRef<string[]>(
    form.getValues('languagesSpoken') || []
  );

  const totalItems = data?.length;
  const visibleItemsCount = Math.ceil(containerHeight / itemHeight);
  const startIndex = Math.max(Math.floor(scrollTop / itemHeight));
  const endIndex = Math.min(totalItems - 1, startIndex + visibleItemsCount);

  const onScroll = () => {
    if (containerRef?.current) {
      const { scrollTop } = containerRef.current;
      setScrollTop(scrollTop);
      form.setValue('languagesSpoken', visibleItems.current);
    }
  };

  useEffect(() => {
    const container: any = containerRef?.current;
    if (container) {
      container?.addEventListener('scroll', onScroll);
    }

    return () => {
      if (container) {
        container?.removeEventListener('scroll', onScroll);
      }
    };
  }, []);

  const onCheckboxClickHandler = (item: string) => {
    const isChecked = visibleItems.current.includes(item);
    let values;
    if (isChecked) {
      values = visibleItems.current.filter((i) => i !== item);
    } else {
      values = [...visibleItems.current, item];
    }
    form.setValue('languagesSpoken', values);
    visibleItems.current = values;
  };

  return (
    <div
      ref={containerRef}
      style={{
        height: `${containerHeight}px`,
        overflowY: 'auto',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'relative',
          height: `${totalItems * itemHeight}px`,
          width: '100%',
        }}
      >
        {data?.slice(startIndex, endIndex).map((item, index) => {
          const isSelected = visibleItems.current.includes(item?.value);
          return (
            <div
              key={index}
              style={{
                height: `${itemHeight}px`,
                position: 'absolute',
                top: `${(startIndex + index) * itemHeight}px`,
                boxSizing: 'border-box',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                background: fromV2 && isSelected ? '#EDF3FB' : 'transparent',
              }}
            >
              <Checkbox
                data-testid={`checkbox-${item?.value}`}
                isChecked={isSelected}
                key={item.value}
                label={item.title}
                onChange={() => onCheckboxClickHandler(item.value)}
                value={item.value}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
